<template>
  <div class="home follow-record">
    <HeaderBar :title="title"></HeaderBar>
    <div class="center-box-no-footer">
      <van-tabs v-model="showPage" class="follow-tab" :ellipsis="false" v-show="false">
        <van-tab v-for="(item,index) in typeList" :key="index" :title="item.name" :name="item.router"></van-tab>
      </van-tabs>
      <phyicalCheck v-if="showPage == 'phyicalCheck' && userMode== 'system'" ref="phyicalCheck"></phyicalCheck>
      <phyicalCheckPatient v-if="showPage == 'phyicalCheck' && userMode== 'patient'" ref="phyicalCheck"></phyicalCheckPatient>
      <followInfo v-if="showPage == 'followInfo'" ref="followInfo"></followInfo>
      <pasthistory v-if="showPage == 'pasthistory'" ref="pasthistory"></pasthistory>
      <family v-if="showPage == 'family'" ref="family"></family>
      <treatment v-if="showPage=='treatment'" ref="treatment"></treatment>
    </div>
  </div>
</template>

<script>
  // 引入服务组件
  import componentsModel from '../base/components.js'
  import phyicalCheck from './phyicalCheck/index'
  import phyicalCheckPatient from './phyicalCheckPatient/index'
  import treatment from './treatment/index'
  import pasthistory from './pasthistory/index'
  import family from './family/index'
  export default {
    name: "page",
    data() {
      return {
        title: "检验/检查报告",
        typeList: [{
          name: "体格/实验室检查",
          router: "phyicalCheck"
        }, {
          name: "诊疗方案",
          router: "treatment"
        }],
        showPage: "phyicalCheck",
        activeIndex: 0
      }
    },
    props: {
      // 当前登录的用户，system为系统用户,patient为患者
      userMode: {
        type: String,
        default: "system"
      },
    },
    components: {
      ...componentsModel,
      phyicalCheck,
      phyicalCheckPatient,
      treatment,
      pasthistory,
      family
    },
    methods: {
      changeType: function(index) {
        this.activeIndex = index
        this.showPage = this.typeList[index].router
      },
      Save: function() {
        this.$refs[this.showPage].Save()
      }
    },
    mounted() {
      //判断是否基线，插入基本数据
      if (JSON.parse(sessionStorage.getItem('bq400')).bq400999 == 0) {
        this.typeList.push({
          name: "相关病史",
          router: "pasthistory"
        }
        // , {
        //   name: "家族史",
        //   router: "family"
        // }
      )
        this.showPage = "phyicalCheck" //this.typeList[0].router
      }
      
      console.log(this.userMode);



    }
  }
</script>

<style scoped>

</style>



